












































































import { Vue, Component } from "vue-property-decorator";
import TaxonomyProfessionalActivityItem from "@/components/taxonomy/ProfessionalActivityTaxonomyItem.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import { DocumentTypeListParams } from "@/getinfo-api/documentType";
import DocumentTypeTaxonomyItem from "@/components/taxonomy/DocumentTypeTaxonomyItem.vue";

@Component({
  components: {
    DocumentTypeTaxonomyItem,
    CustomTable,
    CustomButton,
    TaxonomyProfessionalActivityItem
  }
})
export default class DocumentTypeTaxonomyList extends Vue {
  title!: string | undefined;
  gettingDocumentTypes: boolean = false;

  data() {
    return {
      title: undefined
    };
  }

  get termList() {
    return this.$store.getters["taxonomy/DocTypes/GET_TERMS"];
  }

  get termCount() {
    return this.$store.getters["taxonomy/DocTypes/GET_TERMS_COUNT"];
  }

  applyFilter() {
    this.$store.commit("taxonomy/DocTypes/CLEAR");
    this.getDocumentTypeList();
  }

  getTermByOffset() {
    this.$store.commit("docTemplates/INCREASE_OFFSET");
    this.getDocumentTypeList();
  }

  async getDocumentTypeList() {
    this.gettingDocumentTypes = true;
    let params: DocumentTypeListParams = {
      title: this.title ? this.title : undefined
    };
    await this.$store.dispatch("taxonomy/DocTypes/LIST", params);
    this.gettingDocumentTypes = false;
  }

  clearForm() {
    this.title = undefined;
    this.$store.commit("taxonomy/DocTypes/CLEAR");
    this.getDocumentTypeList();
  }

  beforeDestroy() {
    this.$store.commit("taxonomy/DocTypes/CLEAR");
  }

  created() {
    this.getDocumentTypeList();
  }
}
